import { IconButton } from '@mui/material';
import React from 'react';

import { CopyToClipboard } from 'src/components/CopyToClipboard';
import { CopyIcon } from 'src/components/icons';

interface CopyTextProps {
  value: string;
  iconPosition?: 'start' | 'end';
  spacing?: React.CSSProperties['justifyContent'];
  children?: React.ReactNode;
}

/**
 * Render prop component that allows for copying value
 * and child component will be rendered adjust to copy icon
 */
export const CopyText: React.FC<CopyTextProps> = ({
  value,
  iconPosition = 'start',
  spacing = 'flex-start',
  children,
}) => {
  const handleCopyClicked = (
    ev: React.MouseEvent<HTMLButtonElement>,
    copyFunction: (content: any) => void,
  ) => {
    ev.stopPropagation();
    copyFunction(value);
  };
  const wrappedChildren = (
    <div className="overflow-auto whitespace-nowrap">{children}</div>
  );
  return (
    <div className="flex" style={{ justifyContent: spacing }}>
      {iconPosition === 'end' && wrappedChildren}
      <CopyToClipboard>
        {({ copy }) => (
          <IconButton
            onClick={(ev) => handleCopyClicked(ev, copy)}
            size="small"
          >
            <CopyIcon className="text-[12px] text-black-heading [&_path]:[stroke-width:1.75]" />
          </IconButton>
        )}
      </CopyToClipboard>
      {iconPosition === 'start' && wrappedChildren}
    </div>
  );
};
